export const getRandomRangeArray = (min, max, count) => {
  let result = [];

  const getShuffledBatch = (start, end) => {
    const size = end - start + 1;
    let batch = Array.from({ length: size }, (_, i) => i + start);

    for (let i = batch.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [batch[i], batch[j]] = [batch[j], batch[i]];
    }
    return batch;
  };

  while (result.length < count) {
    const nextBatch = getShuffledBatch(min, max);
    result = [...result, ...nextBatch];
  }

  return result.slice(0, count);
};
